import React from "react";
import FaqAccordion from "../faqAccordion/faqAccordion";

const Blog16 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>

        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        {/* Intro */}
        <p className="sub-paragraph-heading">
          A Practical Guide to Building Wealth in a Fast Moving Financial World
        </p>

        <p className="paragraph-content">
          In 2026, earning money is not enough. Managing it strategically is
          what creates long term stability.
          <br />
          Rising living costs, easy credit access, digital investing apps, and
          social media driven advice make financial decisions more complex than
          ever. This checklist simplifies financial planning into clear,
          actionable steps.
        </p>

        <p className="sub-paragraph-heading">
          Step 1: Define Clear Financial Goals
        </p>

        <p className="paragraph-content">
          Financial planning begins with clarity.
          <br />
          Divide your goals into three categories:
        </p>

        <p className="paragraph-content">
          <b>Short term goals</b>
          <br />
          Examples include travel, gadgets, and emergency fund building.
        </p>

        <p className="paragraph-content">
          <b>Medium term goals</b>
          <br />
          Examples include buying a car, funding higher education, and business
          capital.
        </p>

        <p className="paragraph-content">
          <b>Long term goals</b>
          <br />
          Examples include home purchase, financial independence, and retirement
          corpus.
        </p>

        <p className="paragraph-content">
          Without defined goals, money gets spent without direction.
        </p>

        <p className="sub-paragraph-heading">
          Step 2: Build an Emergency Fund First
        </p>

        <p className="paragraph-content">
          Before investing aggressively, secure your base. Aim to maintain at
          least three to six months of essential expenses in a highly liquid
          account. Why this matters:
        </p>

        <ul className="paragraph-content">
          <li>Protects against job loss</li>
          <li>Prevents dependency on high interest loans</li>
          <li>Provides financial confidence</li>
        </ul>

        <p className="paragraph-content">
          An emergency fund reduces panic decisions during uncertainty.
        </p>

        <p className="sub-paragraph-heading">
          Step 3: Follow a Structured Budget System
        </p>

        <p className="paragraph-content">
          A simple budgeting model can improve savings instantly. One effective
          structure:
        </p>

        <ul className="paragraph-content">
          <li>50 percent for needs</li>
          <li>30 percent for investments and savings</li>
          <li>20 percent for lifestyle and discretionary spending</li>
        </ul>

        <p className="paragraph-content">
          The exact percentages may vary, but investing should never be
          optional. Automate investments immediately after salary credit.
        </p>

        <p className="sub-paragraph-heading">Step 4: Protect Before You Grow</p>

        <p className="paragraph-content">
          Insurance is often ignored by young earners.
          <br />
          Minimum essentials include:
        </p>

        <ul className="paragraph-content">
          <li>Health insurance</li>
          <li>Term life insurance if dependents exist</li>
        </ul>

        <p className="paragraph-content">
          One medical emergency can erase years of savings. Protection ensures
          wealth building is not interrupted.
        </p>

        <p className="sub-paragraph-heading">
          Step 5: Invest According to Time Horizon
        </p>

        <p className="paragraph-content">
          Investment choices must match time duration.
        </p>

        <p className="paragraph-content">
          For <b>short term goals under three years</b>
          <br />
          consider low risk fixed income options.
        </p>

        <p className="paragraph-content">
          For <b>medium term goals between three and seven years</b>
          <br />
          balanced or hybrid investment strategies may be suitable.
        </p>

        <p className="paragraph-content">
          For <b>long term goals above seven years</b>
          <br />
          equity mutual funds, index funds, or direct equity can offer growth
          potential.
        </p>

        <p className="paragraph-content">
          Time reduces volatility impact. Impatience increases risk.
        </p>

        <p className="sub-paragraph-heading">
          Step 6: Manage Debt Strategically
        </p>

        <p className="paragraph-content">
          Debt is not always harmful. Mismanaged debt is. Focus on:
        </p>

        <ul className="paragraph-content">
          <li>Clearing high interest debt first</li>
          <li>Avoiding multiple personal loans simultaneously</li>
          <li>Not revolving credit card balances</li>
        </ul>

        <p className="paragraph-content">
          A healthy financial plan reduces debt gradually each year.
        </p>

        <p className="sub-paragraph-heading">
          Step 7: Conduct an Annual Financial Review
        </p>

        <p className="paragraph-content">At least once every year:</p>

        <ul className="paragraph-content">
          <li>Review investment performance</li>
          <li>Rebalance asset allocation</li>
          <li>Check insurance coverage adequacy</li>
          <li>Track net worth growth</li>
        </ul>

        <p className="paragraph-content">
          Financial planning is not a one time activity. It is a yearly
          discipline.
        </p>

        {/* FAQ */}
        <div className="faq-heading-container">
          <p className="sub-paragraph-heading-faq">
            Frequently asked questions
          </p>
        </div>

        <FaqAccordion>
          <h4 className="faq-question">
            Q1. How much should Millennials invest monthly?
          </h4>
          <p className="faq-answer">
            A practical starting point is at least 20 to 30 percent of monthly
            income. Increase the percentage as income grows.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            Q2. Is financial planning necessary in your twenties?
          </h4>
          <p className="faq-answer">
            Yes. Early planning benefits from compounding and reduces financial
            stress in your thirties.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            Q3. Should I invest before clearing debt?
          </h4>
          <p className="faq-answer">
            High interest debt should usually be cleared first. Moderate
            interest loans can be balanced with investments.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            Q4. How often should I review my financial plan?
          </h4>
          <p className="faq-answer">
            A comprehensive review once a year is sufficient for most
            individuals.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            Q5. What is the biggest mistake young earners make?
          </h4>
          <p className="faq-answer">
            Ignoring budgeting and emergency funds while focusing only on high
            return investments.
          </p>
        </FaqAccordion>

        <br />
        <br />
      </div>
    </div>
  );
};

export default Blog16;
